const tableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true
  },
  {
    prop: 'schedule',
    label: 'Frequency',
    sortable: true
  },
  {
    prop: 'dayOfWeek',
    label: 'Sent on',
    sortable: false
  },
  {
    prop: 'timeOfDay',
    label: 'Sent at',
    sortable: false
  },
  {
    prop: 'deliveryType',
    label: 'Delivery',
    sortable: false
  },
  {
    prop: 'status',
    label: 'Status',
    sortable: true
  },
];

const tableFilters = [
  {
    label: 'Paused',
    name: 'paused',
    search: 'status',
    param: 'paused'
  },
  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      }
    ]
  }
};

export { tableColumns, tableFilters, tableOptions };
